import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Waveform } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { advisorHeaders } from "../lib/clarity";

export default function AudioPreloadCard() {
  const [s, setS] = useState(null);
  const load = () => api.get("/admin/retention/preload-audio", advisorHeaders()).then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const running = s?.job?.status === "running";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [running]);

  const start = async () => {
    try { const r = await api.post("/admin/retention/preload-audio", {}, advisorHeaders()); setS(r.data); toast.success("Pre-load started in the background."); }
    catch { toast.error("Could not start pre-load."); }
  };
  const cancel = async () => { await api.post("/admin/retention/preload-audio/cancel", {}, advisorHeaders()); toast.success("Cancelling…"); setTimeout(load, 1500); };
  if (!s) return null;
  const j = s.job;

  return (
    <div data-testid="audio-preload-card" className="card-surface p-6 mt-10">
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div>
          <p className="eyebrow flex items-center gap-2"><Waveform size={14} /> Check-in audio pre-load</p>
          <p className="font-display text-3xl mt-2"><span data-testid="preload-ready" className="gold-text">{s.ready}</span> / {s.total} episodes ready</p>
          <p data-testid="preload-bonus" className="text-xs text-exodus-muted mt-1">Bonus reward episodes: {s.bonus_ready ?? 0} / {s.bonus_total ?? 3} ready · Check-ins only pick ready episodes until the full set is generated.</p>
        </div>
        <div className="flex gap-3">
          {running ? (
            <button data-testid="preload-cancel" onClick={cancel} className="btn-ghost">Cancel</button>
          ) : (
            <button data-testid="preload-start" onClick={start} disabled={s.ready >= s.total} className="btn-gold">Pre-load check-in audio</button>
          )}
        </div>
      </div>
      <div className="h-1.5 bg-exodus-border mt-5"><div className="h-1.5 bg-exodus-gold" style={{ width: `${(s.ready / s.total) * 100}%`, transition: "width 600ms" }} /></div>
      {j && (
        <p data-testid="preload-status" className={`text-xs mt-3 ${j.status === "stopped" ? "text-orange-300" : "text-exodus-muted"}`}>
          Last run: {j.status} · {j.position}/{j.total} checked · {j.generated} generated · {j.skipped} already ready · {j.failed} failed{j.last ? ` · last: ${j.last}` : ""}
          {j.error ? ` — ${j.error}` : ""}
        </p>
      )}
    </div>
  );
}
